<template>
  <TableLayout :permissions="['meihui:posterTemplate:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="名称"><el-input v-model="searchForm.name" placeholder="模板名称" @keypress.enter.native="search" /></el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" icon="el-icon-plus" v-permissions="['meihui:posterTemplate:create']" @click="$refs.opera.open('新建海报背景图')">新建</el-button></li>
        <li><el-button icon="el-icon-link" v-permissions="['meihui:posterTemplate:create']" @click="importVisible = true">按链接迁移</el-button></li>
        <li><el-button icon="el-icon-delete" v-permissions="['meihui:posterTemplate:delete']" @click="deleteByIdInBatch">批量删除</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="bgUrl" label="背景图" width="130">
          <template slot-scope="{row}">
            <el-image v-if="row.bgUrl" :src="imageUrl(row.bgUrl)" :preview-src-list="[imageUrl(row.bgUrl)]" fit="cover" style="width: 84px; height: 84px" />
            <span v-else style="color:#c0c4cc">无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80" />
        <el-table-column prop="isEnabled" label="启用" width="80"><template slot-scope="{row}"><el-switch :value="!!row.isEnabled" disabled /></template></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" icon="el-icon-edit" v-permissions="['meihui:posterTemplate:update']" @click="$refs.opera.open('编辑海报背景图', row)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" v-permissions="['meihui:posterTemplate:delete']" @click="deleteById(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="tableData.pagination" @size-change="handleSizeChange" @current-change="handlePageChange" />
    </template>
    <operaposterTemplateWindow ref="opera" :share-background-only="true" width="80%" @success="handlePageChange" />
    <el-dialog title="按图片链接迁移到 OSS" :visible.sync="importVisible" width="620px" append-to-body>
      <p style="margin-top:0;color:#606266">每行一张图，格式：名称 | 图片 HTTPS 链接。系统会下载图片、上传自有 OSS，并新建为分享背景图。</p>
      <el-input v-model="importText" type="textarea" :rows="10" placeholder="春日背景 | https://example.com/poster.jpg" />
      <span slot="footer"><el-button @click="importVisible = false">取消</el-button><el-button type="primary" :loading="isImporting" @click="importByUrls">开始迁移</el-button></span>
    </el-dialog>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import operaposterTemplateWindow from '../posterTemplate/operaposterTemplateWindow'

const FIXED_MODEL = { scene: 'diaryShare', type: 'shareBackground', deleted: 0 }

export default {
  name: 'SharePosterTemplate',
  extends: BaseTable,
  components: { TableLayout, Pagination, operaposterTemplateWindow },
  data () {
    return {
      // 通用分页会将非空字段作为精确查询条件；空字符串会被拼成 name = ''，
      // 因此首次加载和重置时必须用 null 表示“不按名称筛选”。
      searchForm: { ...FIXED_MODEL, name: null },
      importVisible: false,
      importText: '',
      isImporting: false,
      imgUrl: process.env.VUE_APP_API_IMG
    }
  },
  created () {
    this.config({ module: '海报模板管理', api: '/rentHouse/sharePosterTemplate', 'field.id': 'id', 'field.main': 'name' })
    this.search()
  },
  methods: {
    reset () {
      this.searchForm = { ...FIXED_MODEL, name: null }
      this.search()
    },
    imageUrl (url) {
      return /^https?:\/\//i.test(url) ? url : this.imgUrl + url
    },
    importByUrls () {
      const items = this.importText.split(/\r?\n/).map((line, index) => {
        const pair = line.split('|').map(item => item.trim())
        return { name: pair.length > 1 ? pair[0] : `海报背景图${index + 1}`, imageUrl: pair.length > 1 ? pair.slice(1).join('|') : pair[0], sortOrder: index }
      }).filter(item => item.imageUrl)
      if (!items.length) {
        this.$message.warning('请至少填写一条图片链接')
        return
      }
      this.isImporting = true
      this.api.importSharePosterTemplates(items)
        .then(() => {
          this.$message.success(`已迁移 ${items.length} 张图片`)
          this.importVisible = false
          this.importText = ''
          this.search()
        })
        .catch(error => this.$tip.apiFailed(error))
        .finally(() => { this.isImporting = false })
    }
  }
}
</script>
